export const providerQueryKeys = {
  base: (providerId: string) => [ 'provider', providerId ],
  activePatients: (providerId: string) => [ 'provider', providerId, 'activePatients' ],
  details: (providerId: string) => [ 'provider', providerId, 'details' ],
  activationEvents: (providerId: string) => [ 'provider', providerId, 'activation', 'events' ],
  licenseStates: (providerId: string) => [ 'provider', providerId, 'licenseStates' ],
  licenses: (providerId: string) => [ 'provider', providerId, 'license' ],
  license: (providerId: string, licenseId: string) => [ 'provider', providerId, 'license', licenseId ],
  licensesCollabAgreements: (providerId: string) => [ 'provider', providerId, 'licensesCollabAgreements' ],
  missingPayers: (providerId: string) => [ 'user', providerId, 'missingPayers' ],
  insurances: (providerId: string) => [ 'user', providerId, 'insurances' ],
  statesSelection: (providerId: string) => [ 'provider', providerId, 'statesSelection' ],
  outOfOffice: (providerId?: string) => [ 'provider', providerId, 'outOfOffice' ],

  financesTotal: (providerId: string) => [ 'provider', providerId, 'finance', 'total' ],
  financesRange: (providerId: string) => [ 'provider', providerId, 'finance', 'range' ],
  financesMonths: (providerId: string, rangeFrom: string, rangeTo: string) => [ 'provider', providerId, 'finance', 'months', rangeFrom, rangeTo ],
  financesDisplayPeriod: (providerId: string) => [ 'provider', providerId, 'finance', 'display-periods' ],
  financesPeriod: (providerId: string, period: string) => [ 'provider', providerId, 'finance', 'period', period ],

  cptRates: (providerId: string) => [ 'provider', providerId, 'cptRates' ],
  publicProfiles: (providerId: string) => [ 'provider', providerId, 'publicProfiles' ],
  supervisees: (providerId: string) => [ 'provider', providerId, 'supervisees' ],
  supervisee: (providerId: string, matchId: string) => [ 'provider', providerId, 'supervisees', matchId ],
  supervisionMeetings: (providerId: string, matchId: string) => [ 'provider', providerId, 'supervisees', matchId, 'meetings' ],
  supervisionMeeting: (providerId: string, matchId: string, meetingId: string) => [ 'provider', providerId, 'supervisees', matchId, 'meetings', meetingId ],
};
